import { Fund } from "creso-core/types";
import { AmcLogo } from "web-core/components";
import { cn } from "web-design-system";
import { useMemo } from "react";
import { useWindowSize } from "usehooks-ts";

function RankIcon({ rank }: { rank: number }) {
  return (
    <img
      className="size-7 shrink-0"
      src={`/assets/images/ranks/rank-${rank}.webp`}
      alt={`Rank ${rank}`}
    />
  );
}

/** Row of fund logos, names, and rank badges for the compare report. */
export function FundsCompareFundStrip({
  funds,
  className,
  offset,
}: {
  funds: Fund[];
  className?: string;
  offset?: number;
}) {
  const { width } = useWindowSize();

  const labelWidth = useMemo(() => {
    if (offset) return offset;
    if (width < 1024) return 150;
    let lWidth = 320;
    if (funds.length > 2) lWidth = 240;
    return lWidth;
  }, [width, funds.length, offset]);

  return (
    <div className={cn("flex flex-row justify-start w-full", className)}>
      <div className="shrink-0" style={{ width: labelWidth }} />
      {funds.map((fund, idx) => {
        return (
          <div
            key={`${fund.fund_id}-${idx}`}
            className="flex flex-1 flex-row gap-3 items-center p-1"
          >
            <div className="flex flex-row gap-3 rounded-lg size-full bg-card px-3 py-2 items-center">
              <AmcLogo amc_code={fund.provider_company_id ?? null} />
              <span className="text-sm font-medium line-clamp-2 leading-snug flex-1">
                {fund.legal_name}
              </span>
              {fund.ranking?.category_rank ? (
                <RankIcon rank={fund.ranking?.category_rank} />
              ) : null}
            </div>
          </div>
        );
      })}
    </div>
  );
}
